import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Box from '@mui/material/Box';
import useIsMobile from '../../hooks/useIsMobile';
import LogoMain from '../logo/LogoMain';
import ArrowBackButton from '../../icons/button-icons/ArrowBackButton';
import CloseButton from '../../icons/button-icons/CloseButton';
import useAssetronOverlayDialogStyles from './styles/useAssetronOverlayDialogStyles';

interface AssetronOverlayDialogProps {
  open: boolean;
  content: React.ReactNode;
  isCloseVisible?: boolean;
  onClose: () => void;
  isBackVisible?: boolean;
  onBack?: () => void;
  isLogoVisible?: boolean;
  hasContentPadding?: boolean;
  fitContentHeight?: boolean;
}

function AssetronOverlayDialog({
  open,
  content,
  isCloseVisible = true,
  onClose,
  isBackVisible = false,
  onBack = () => {},
  isLogoVisible = false,
  hasContentPadding = false,
  fitContentHeight = false,
}: Readonly<AssetronOverlayDialogProps>) {
  const isSmallScreen = useIsMobile();
  const {
    paperProps,
    backButtonBoxStyle,
    closeButtonBoxStyle,
    logoDialogStyle,
    DialogContentStyle,
  } = useAssetronOverlayDialogStyles(
    isLogoVisible,
    hasContentPadding,
    fitContentHeight,
  );

  const handleClose = (event: React.MouseEvent, reason: string) => {
    if (reason !== 'backdropClick') {
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullScreen={isSmallScreen}
      slotProps={{
        paper: isSmallScreen
          ? undefined
          : {
              style: { ...paperProps },
            },
      }}
    >
      {(isBackVisible || isCloseVisible) && (
        <DialogTitle>
          {isBackVisible && (
            <Box
              onClick={onBack}
              sx={backButtonBoxStyle}
              data-testid="overlay-dialog-back-button"
            >
              <ArrowBackButton />
            </Box>
          )}
          {isCloseVisible && (
            <Box
              onClick={onClose}
              sx={closeButtonBoxStyle}
              data-testid="overlay-dialog-close-button"
            >
              <CloseButton />
            </Box>
          )}
        </DialogTitle>
      )}
      <DialogContent sx={DialogContentStyle}>
        {isLogoVisible && (
          <Box sx={logoDialogStyle}>
            <LogoMain />
          </Box>
        )}
        {content}
      </DialogContent>
    </Dialog>
  );
}

export default AssetronOverlayDialog;
